import { render, staticRenderFns } from "./es-table-pagination.vue?vue&type=template&id=0cc388c5&lang=pug"
import script from "./es-table-pagination.vue?vue&type=script&lang=js"
export * from "./es-table-pagination.vue?vue&type=script&lang=js"
import style0 from "./es-table-pagination.vue?vue&type=style&index=0&id=0cc388c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports